import DownloadIcon from '@mui/icons-material/Download'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {Button, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material'
import {envBackHost, envImagePath} from 'GLOBAL/envVariables'
import {searchWaitingLottie, noImage} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import Lottie from 'lottie-react'
import {installerAssignFilter} from 'pages/install/dataConfig/declearFilters'
import InstallAutocomplete from 'pages/install/layout/InstallAutocomplete'
import InstallCompleteListModal from 'pages/install/modules/installModalComponents/installCompleteListModal'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {customerUninstall, getInstallList, imageDownload} from 'utils/apiCalling/api'

const InstallStatus = (props: any) => {
  const userInfo = useSelector((state: any) => state.userInfo.userInfo)
  const [filter, setFilter] = useState<any>(installerAssignFilter)
  const [installCompleteList, setInstallCompleteList] = useState<any>(null)
  const [installDetailInfo, setInstallDetailInfo] = useState<any>(null)
  const [detailCustomerInfo, setDetailCustomerInfo] = useState<any>(null)
  const [modalStatus, setModalStatus] = useState<boolean>(false)
  const [infoDialog, setInfoDialog] = useState<{open: boolean; title: string; message: string}>({
    open: false,
    title: '',
    message: '',
  })

  const modalOpen = () => setModalStatus(true)
  const modalClose = () => setModalStatus(false)

  /**
   * 여기에도 필요하네
   */
  const getInstallCompleteListCall = () => {
    getInstallList(userInfo, 'complete', filter, {
      success: (res: any) => {
        setInstallCompleteList(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: () => {},
    })
  }

  const getInstallDetailInfo = (rowValue: any) => {
    const ranges = [
      {startDate: dayjs().subtract(7, 'day'), endDate: dayjs()},
      {startDate: dayjs().subtract(30, 'day'), endDate: dayjs()},
      {startDate: dayjs().subtract(60, 'day'), endDate: dayjs()},
      {startDate: dayjs().subtract(90, 'day'), endDate: dayjs()},
      {startDate: dayjs(rowValue.completeAt).subtract(3, 'day'), endDate: dayjs(rowValue.completeAt).add(3, 'day')},
    ]

    const fetchWithRange = (index: number) => {
      if (index >= ranges.length) return
      const {startDate, endDate} = ranges[index]
      axiosWithAuth()
        .get(
          `${envBackHost}/${rowValue.officeId}/customer/${rowValue.customerNumber}/checkmeter?startDate=${startDate.format('YYYYMMDD')}&endDate=${endDate.format('YYYYMMDD')}`
        )
        .then((res) => {
          if (res.data.res?.length > 0) {
            setInstallDetailInfo(res.data.res[0])
          } else {
            fetchWithRange(index + 1)
          }
        })
    }

    fetchWithRange(0)
  }

  const unInstall = () => {
    customerUninstall(detailCustomerInfo?.idx, {
      success: (res: any) => {
        console.log(res)
        if (res.resultCode === 0) {
          getInstallCompleteListCall()
          setDetailCustomerInfo(null)
          setInstallDetailInfo(null)
        }
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: () => {},
    })
  }
  const downloadCurrentImage = async () => {
    if (!installDetailInfo?.filePath) return
    await imageDownload(
      installDetailInfo.filePath,
      32,
      255,
      installDetailInfo.rotate ?? 0,
      detailCustomerInfo?.customerName
    )
  }

  useEffect(() => {
    getInstallCompleteListCall()
  }, [])

  return (
    <div className={'container-fluid w-100 px-0 mb-5 flex-grow-1'}>
      <div className={'card card-body h-100'}>
        <div className={'d-grid justify-content-end'}>
          <Button variant={'contained'} color={'primary'} onClick={modalOpen}>
            모든 설치고객 보기
          </Button>
        </div>
        <InstallAutocomplete
          id='choose-install-customer'
          label='설치완료 고객 검색'
          placeholder='설치 완료한 고객 검색해주세요.'
          options={installCompleteList ?? []}
          getOptionLabel={(option: any) =>
            `${option?.customerName}[${option?.customerNumber}] - ${dayjs(option?.completeAt)?.format('YY.MM.DD')}`
          }
          isOptionEqualToValue={(option: any, value: any) =>
            option.customerNumber === value.customerNumber &&
            option.completeAt === value.completeAt
          }
          onChange={(rowValue) => {
            setDetailCustomerInfo(rowValue)
            setInstallDetailInfo(null)
            getInstallDetailInfo(rowValue)
          }}
        />
        <div className={'border border-gray-400 rounded-2'} style={{minHeight: 100}}>
          {!detailCustomerInfo && (
            <div className={'d-grid justify-content-center'}>
              <Lottie animationData={searchWaitingLottie} style={{width: 180}} />
            </div>
          )}
          {detailCustomerInfo && (
            <div>
              {/*<img src={envImagePath + installDetailInfo?.filePath} alt={'current'} />*/}
              <div className={'bg-dark text-center py-1 '}>
                <span className={'text-white fs-3 fw-bolder'}>단말기 이미지</span>
              </div>
              {detailCustomerInfo?.deviceType === 'analog' ? (
                <>
                  <img
                    src={`${envImagePath}${installDetailInfo?.filePath}`}
                    alt={'current'}
                    className={''}
                    width={'100%'}
                    onError={(e) => {(e.target as HTMLImageElement).src = noImage}}
                  />
                  <div className={'px-3 pt-2 pb-1'}>
                    <Button
                      variant={'outlined'}
                      color={'primary'}
                      fullWidth
                      startIcon={<DownloadIcon />}
                      disabled={!installDetailInfo?.filePath}
                      onClick={downloadCurrentImage}
                    >
                      현재 이미지 다운로드
                    </Button>
                    <p className={'text-muted fs-7 text-center mb-0 mt-1'}>
                      * 설치 시점이 아닌 <b>현재 수신된 최신 이미지</b>를 다운로드합니다.
                    </p>
                  </div>
                </>
              ) : (
                <h5 className={'mt-4 text-center text-danger fw-bolder'}>디지털 단말기 입니다.</h5>
              )}
              <div className={'row gap-2 fs-3 fw-bolder px-5 my-3'}>
                <div className={'d-flex gap-2'}>
                  <span>이름:</span>
                  <span>{detailCustomerInfo?.customerName}</span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>고객 번호:</span>
                  <span>{detailCustomerInfo?.customerNumber}</span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>주소:</span>
                  <span>
                    {detailCustomerInfo?.addressNumber === ''
                      ? detailCustomerInfo?.addressRoad
                      : detailCustomerInfo?.addressNumber}
                  </span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>온도:</span>
                  {detailCustomerInfo?.meterReadVersion === 'v2.20' ? (
                    <span>
                      {detailCustomerInfo?.temperature < 90
                        ? `${detailCustomerInfo?.temperature}°C`
                        : `-`}
                    </span>
                  ) : (
                    <span>X</span>
                  )}
                </div>
                <hr className={'my-1'} />
                <div className={'d-flex align-items-center gap-1'}>
                  <span className={'fs-5 text-muted fw-bold'}>설치 당시 통신 현황</span>
                  <IconButton
                    size={'small'}
                    onClick={() =>
                      setInfoDialog({
                        open: true,
                        title: '설치 당시 통신 현황',
                        message:
                          '설치 완료 당시 기록된 전파 세기 및 품질 정보입니다.\n- 표시는 설치 당시 통신 환경 불안정으로 인해 데이터가 수집되지 않은 경우입니다.',
                      })
                    }
                  >
                    <InfoOutlinedIcon fontSize={'medium'} color={'action'} />
                  </IconButton>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>일시:</span>
                  <span>
                    {dayjs(detailCustomerInfo?.completeAt)?.format('YY년 MM월 DD일 HH:mm:ss')}
                  </span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>전파 세기:</span>
                  <span>
                    {detailCustomerInfo?.signalStrength != null
                      ? `${detailCustomerInfo.signalStrength}dBm`
                      : '-'}
                  </span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>전파 품질:</span>
                  <span>
                    {detailCustomerInfo?.linkquality != null ? `${detailCustomerInfo.linkquality}dB` : '-'}
                  </span>
                </div>
                <hr className={'my-1'} />
                <div className={'d-flex align-items-center gap-1'}>
                  <span className={'fs-5 text-muted fw-bold'}>현재 이미지 수신 상태</span>
                  <IconButton
                    size={'small'}
                    onClick={() =>
                      setInfoDialog({
                        open: true,
                        title: '현재 이미지 수신 상태',
                        message:
                          '가장 최근 수신된 이미지 기준의 전파 세기 및 품질 정보입니다.\n- 표시는 해당 시점 통신 환경 불안정으로 인해 데이터가 수집되지 않은 경우입니다.',
                      })
                    }
                  >
                    <InfoOutlinedIcon fontSize={'medium'} color={'action'} />
                  </IconButton>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>일시:</span>
                  <span>
                    {installDetailInfo?.createAt
                      ? dayjs(installDetailInfo.createAt).format('YY년 MM월 DD일 HH:mm:ss')
                      : '-'}
                  </span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>전파 세기:</span>
                  <span>
                    {installDetailInfo?.signalStrength != null
                      ? `${installDetailInfo.signalStrength}dBm`
                      : '-'}
                  </span>
                </div>
                <div className={'d-flex gap-2'}>
                  <span>전파 품질:</span>
                  <span>
                    {installDetailInfo?.linkquality != null ? `${installDetailInfo.linkquality}dB` : '-'}
                  </span>
                </div>
              </div>
              <div className={'p-2'}>
                <Button variant={'contained'} color={'error'} fullWidth onClick={() => unInstall()}>
                  설치취소
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <Dialog open={infoDialog.open} onClose={() => setInfoDialog({...infoDialog, open: false})}>
        <DialogTitle sx={{fontSize: '1.6rem', fontWeight: 'bold'}}>{infoDialog.title}</DialogTitle>
        <DialogContent>
          <p style={{whiteSpace: 'pre-line', fontSize: '1.3rem'}}>{infoDialog.message}</p>
        </DialogContent>
      </Dialog>
      <InstallCompleteListModal
        open={modalStatus}
        onClose={modalClose}
        user={userInfo}
        allList={installCompleteList}
        name={'install-complete-modal'}
      />
    </div>
  )
}

export default InstallStatus
